<template>
  <div id="socials">
    <b-container class="footer-container">
      <a
        @click="analyticsHelper.clickedLink('github - personal')"
        href="https://github.com/danDoDev"
        target="_blank"
      >
        <div class="github">
          <img
            :src="
              require(!global.darkMode
                ? '@/assets/images/icons/github-light.png'
                : '@/assets/images/icons/github-dark.png')
            "
          />
        </div>
      </a>
      <a
        @click="analyticsHelper.clickedLink('linkedin')"
        href="https://www.linkedin.com/in/daniel-gurin"
        target="_blank"
      >
        <img
          class="linkedin"
          :src="require('@/assets/images/icons/linkedin.png')"
      /></a>
    </b-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { languageHelper, analyticsHelper } from "@/helpers";

export default {
  name: "Footer",
  data() {
    return { languageHelper, analyticsHelper };
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#socials {
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 60px 0;

  .footer-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @media (max-width: $lg) {
      padding: 50px 60px 33px 60px;
    }
    @media (max-width: $md) {
      flex-direction: column;
    }
  }
  @media (max-width: $xl) {
    .container {
      margin: 0;
      width: 100%;
      max-width: 100%;
    }
  }
  .github {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 40px;
    @media (max-width: $md) {
      margin-right: 0;
      margin-bottom: 24px;
      span {
        margin-right: 0 !important;
      }
    }
    img {
      height: 30px;
      width: 30px;
    }
    span {
      font-size: 18px;
      font-family: $font-primary;
      color: $lt-dark-gray;
      margin-right: 10px;
    }
  }
  a {
    text-decoration: none;
    outline: none;
  }

  img,
  svg {
    height: 30px;
    width: auto;
  }
}
</style>


<style lang="scss" >
.dark {
  #socials {
    background: $dt-bg-color;

    .github {
      span {
        color: $dt-font-color;
      }
    }
  }
}
</style>

